export const focusOutlineOuter = {
  outline: '$borderWidths$outerFocus solid $colors$interactiveFocusOuter',
  outlineOffset: '$borderWidths$outerFocus',
};

export const focusOutlineInner = {
  boxShadow:
    'inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner',
  // Visible in Windows high-contrast themes
  outline: '$borderWidths$innerFocus  solid transparent',
};

/**
 * Override utility that switches GDS component focus styles from `:focus` to
 * `:focus-visible`. Spread this into a Stitches `css` prop or styled-component
 * definition to opt a component into keyboard-only focus indicators.
 *
 * Uses `outline` (not `box-shadow`) for the visible ring so Windows High
 * Contrast Mode continues to render the focus indicator — HCM honours
 * `outline` but strips `box-shadow`.
 *
 * The transparent outline on `:focus` ensures HCM still reserves space for
 * the indicator without showing it on mouse click.
 */
export const focusVisibleOverrideOuter = {
  '&:focus': {
    outline: '$borderWidths$outerFocus solid transparent',
    outlineOffset: '$borderWidths$outerFocus',
  },
  '&:focus-visible': {
    ...focusOutlineOuter,
  },
};

export const focusVisibleOverrideInner = {
  '&:focus': {
    boxShadow: 'none',
    // Transparent outline keeps HCM space reservation without visible ring
    outline: '$borderWidths$innerFocus solid transparent',
  },
  '&:focus-visible': {
    ...focusOutlineInner,
  },
};
